<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <label>Nome</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="paciente.nome"
                    id="nome"
                  />
                </div>
                <div class="col-md-4">
                  <label>Nome da mãe</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="paciente.nome_mae"
                  />
                </div>
                <div class="col-md-4">
                  <label><span class="required">*</span> E-mail</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="paciente.email"
                  />
                </div>
                <div class="col-md-3">
                  <label><span class="required">*</span> Cartão SUS</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="paciente.cartao_sus"
                  />
                </div>
                <div class="col-md-2">
                  <label><span class="required">*</span> Telefone</label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'(99) 9999-9999'"
                    v-model="paciente.telefone"
                  />
                </div>
                <div class="col-md-2">
                  <label><span class="required">*</span> Celular</label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'(99) 99999-9999'"
                    v-model="paciente.celular"
                  />
                </div>
                <div class="col-md-2">
                  <label><span class="required">*</span> RG</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="paciente.rg"
                  />
                </div>
                <div class="col-md-3">
                  <label><span class="required">*</span> CPF</label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'999.999.999-99'"
                    v-model="paciente.cpf"
                  />
                </div>
                <div class="col-md-6">
                  <label>Empresa</label>
                  <v-select
                    :options="empresas"
                    :reduce="(empresas) => empresas.id"
                    :label="'nome_fantasia'"
                    v-model="paciente.empresa_id"
                    class="vselect"
                  ></v-select>
                </div>
                <div class="col-md-6">
                  <label>Atenção continuada</label>
                  <v-select
                    :options="atencao_continuadas"
                    :reduce="(atencao_continuadas) => atencao_continuadas.id"
                    :label="'nome'"
                    v-model="paciente.atencao_continuada_id"
                    class="vselect"
                  ></v-select>
                </div>
                <div class="col-md-12">
                  <label>Alergias</label>
                  <input
                    type="text"
                    v-model="paciente.alergias"
                    class="form-control"
                  />
                </div>
                <div class="col-md-12">
                  <hr />
                </div>
                <div class="col-md-2">
                  <label><span class="required">*</span> CEP</label>
                  <input
                    type="text"
                    v-model="paciente.cep"
                    class="form-control"
                    v-on:keyup="buscar"
                    v-mask="'99999-999'"
                  />
                </div>
                <div class="col-md-5">
                  <label> <span class="required">*</span> Logradouro</label>
                  <input
                    type="text"
                    v-model="paciente.logradouro"
                    class="form-control"
                  />
                </div>
                <div class="col-md-2">
                  <label><span class="required">*</span> Nº</label>
                  <input
                    type="text"
                    id="inputNumero"
                    v-model="paciente.numero"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label>Complemento</label>
                  <input
                    type="text"
                    v-model="paciente.complemento"
                    class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label><span class="required">*</span> Bairro</label>
                  <input
                    type="text"
                    v-model="paciente.bairro"
                    class="form-control"
                  />
                </div>
                <div class="col-md-5">
                  <label><span class="required">*</span> Cidade</label>
                  <input
                    type="text"
                    v-model="paciente.cidade"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label><span class="required">*</span> Estado</label>
                  <input
                    type="text"
                    v-model="paciente.estado"
                    class="form-control"
                  />
                </div>
                <div class="col-md-12 text-right">
                  <hr />
                  <router-link to="/pacientes" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar <i class="fa fa-save"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      paciente: {
        cep: "",
        logradouro: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
      },
      empresas: [],
      atencao_continuadas: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "pacientes";

      self.$loading(true);

      if (self.paciente.id) {
        api += "/" + self.paciente.id;
        self.paciente._method = "PUT";
      }

      axios
        .post(api, self.paciente)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/pacientes");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.paciente.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.paciente.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }

            self.endereco = endereco;
            self.paciente.logradouro = self.endereco.logradouro;
            self.paciente.bairro = self.endereco.bairro;
            self.paciente.estado = self.endereco.uf;
            self.paciente.cidade = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getPacientes: function (id) {
      const self = this;
      const api = self.$store.state.api + "pacientes/" + id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.$loading(false);
          self.paciente = response.data.data[0];
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getEmpresas: function () {
      const self = this;
      const api = self.$store.state.api + "empresas";

      axios
        .get(api)
        .then((response) => {
          self.empresas = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getAtencaoContinuada: function () {
      const self = this;
      const api = self.$store.state.api + "atencao_continuadas";

      axios
        .get(api)
        .then((response) => {
          self.atencao_continuadas = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    $("#nome").focus();
    self.getEmpresas();
    self.getAtencaoContinuada();

    let id = self.$route.params.id;
    if (id) {
      self.getPacientes(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>